import React, { useState } from 'react';
import { Card, Accordion } from 'react-bootstrap';
import { FaBookOpen, FaLightbulb, FaQuestionCircle, FaChevronDown, FaChevronUp } from 'react-icons/fa';

const sectionHeaderStyle = {
  fontSize: '0.8rem',
  fontWeight: 700,
  textTransform: 'uppercase',
  letterSpacing: '0.5px',
  color: 'var(--text-muted, #6c757d)',
  marginBottom: '0.75rem',
  display: 'flex',
  alignItems: 'center',
  gap: '0.5rem',
};

// `className` lets a page that puts the guide at the TOP swap the default
// top margin for a bottom one.
const UserGuide = ({ title = 'User Guide', steps = [], tips = [], faq = [], className = 'mt-4' }) => {
  const [collapsed, setCollapsed] = useState(true);

  return (
    <Card
      className={className}
      style={{
        border: '1px solid var(--border-subtle, #dee2e6)',
        borderLeft: '4px solid #0d6efd',
        borderRadius: '0.5rem',
        background: 'var(--surface-raised, #fff)',
      }}
    >
      <Card.Header
        onClick={() => setCollapsed(!collapsed)}
        style={{
          background: 'transparent',
          border: 'none',
          cursor: 'pointer',
          padding: '0.75rem 1rem',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
          <FaBookOpen style={{ color: '#0d6efd', fontSize: '1rem' }} />
          <span style={{ fontWeight: 600, fontSize: '0.9rem', color: 'var(--text-primary)' }}>
            {title}
          </span>
        </div>
        {collapsed
          ? <FaChevronDown style={{ color: 'var(--text-muted)', fontSize: '0.75rem' }} />
          : <FaChevronUp style={{ color: 'var(--text-muted)', fontSize: '0.75rem' }} />
        }
      </Card.Header>

      {!collapsed && (
        <Card.Body style={{ padding: '0.75rem 1rem 1rem' }}>

          {steps.length > 0 && (
            <div style={{ marginBottom: '1.25rem' }}>
              <div style={sectionHeaderStyle}>
                <FaBookOpen /> Getting Started
              </div>
              <ol style={{ paddingLeft: '1.25rem', margin: 0, fontSize: '0.85rem', lineHeight: 1.7 }}>
                {steps.map((step, i) => (
                  <li key={i} style={{ marginBottom: '0.5rem' }}>
                    <strong>{step.title}</strong>
                    {step.description && <span style={{ color: 'var(--text-secondary, #495057)' }}> &mdash; {step.description}</span>}
                  </li>
                ))}
              </ol>
            </div>
          )}

          {tips.length > 0 && (
            <div style={{ marginBottom: '1.25rem' }}>
              <div style={sectionHeaderStyle}>
                <FaLightbulb style={{ color: '#ffc107' }} /> Tips
              </div>
              <ul style={{ paddingLeft: '1.25rem', margin: 0, fontSize: '0.85rem', lineHeight: 1.7 }}>
                {tips.map((tip, i) => (
                  <li key={i} style={{ marginBottom: '0.5rem', color: 'var(--text-secondary, #495057)' }}>{tip}</li>
                ))}
              </ul>
            </div>
          )}

          {faq.length > 0 && (
            <div style={{ marginBottom: '0.25rem' }}>
              <div style={sectionHeaderStyle}>
                <FaQuestionCircle style={{ color: '#0dcaf0' }} /> Frequently Asked Questions
              </div>
              <Accordion flush>
                {faq.map((item, i) => (
                  <Accordion.Item
                    eventKey={String(i)}
                    key={i}
                    style={{
                      background: 'transparent',
                      border: 'none',
                      borderBottom: i < faq.length - 1 ? '1px solid var(--border-subtle, #dee2e6)' : 'none',
                    }}
                  >
                    <Accordion.Header
                      style={{ fontSize: '0.85rem' }}
                    >
                      <span style={{ fontWeight: 600, fontSize: '0.85rem' }}>{item.question}</span>
                    </Accordion.Header>
                    <Accordion.Body style={{ fontSize: '0.83rem', color: 'var(--text-secondary, #495057)', padding: '0.5rem 1.25rem 0.75rem' }}>
                      {item.answer}
                    </Accordion.Body>
                  </Accordion.Item>
                ))}
              </Accordion>
            </div>
          )}
        </Card.Body>
      )}
    </Card>
  );
};

export default UserGuide;
